import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BootClosedFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M20.0001 8.61964L19.1871 8.15961C18.2419 7.57324 17.1596 7.2627 16.0552 7.2627L11.76 7.26364C11.1846 7.29112 10.6178 7.41641 10.0824 7.63407L3.9939 10.2031V15.4951L6.55092 16.6567C7.54336 19.9753 11.4681 19.7447 12.4652 17.1535H20.0001V8.61964Z"
      />
    </SvgIcon>
  );
});
